import React, { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import {
  renderFieldText,
  RenderFieldPhone,
  renderHiddenFieldText,
} from "@basecomponent";
import { classNames } from "@utilscommon";
import ImageCropper from "@imagecropper";
import LocaleStrings from "@language";
import { useLocalStorage, LOCAL_STORAGE } from "@useLocalStorage";

const FixedFields = (props) => {
  let {
    source,
    formValues,
    checkoutFormData,
    dynamicFormCommonSetting,
    countryList,
  } = props;
  const { getLocalStorage } = useLocalStorage();
  const socialDetails = getLocalStorage(LOCAL_STORAGE.USER_SOCIAL_DETAILS);
  const loginScreen = getLocalStorage(LOCAL_STORAGE.LOGIN_SCREEN);
  // console.log("checkoutFormData :- ", checkoutFormData);
  // console.log({ dynamicFormCommonSetting });
  // console.log("formValues :- ", formValues);

  // Check if phone numbed exists or not in checkout form
  let formJson = checkoutFormData?.data?.formjson ?? "{}";
  let formArray = JSON.parse(formJson);
  let checkPhone = _.filter(formArray, (obj) => obj.name === "phonenumber");
  let countrycode = checkPhone?.[0]?.defaultvalue ?? ""; // default country code checking
  let dropdowndisabled =
    countrycode && countrycode !== "" ? checkPhone?.[0]?.isrestricted : false; // disabled country dropdownlist
  let profileOptionn = checkoutFormData?.data?.profileimage ?? "optional";
  // console.log("profileOptionn :- ", profileOptionn);
  let imagePreviewUrl =
    formValues?.profileurl ?? socialDetails?.profileurl ?? "";
  let speakerimagePreviewUrl =
    formValues?.speakerprofileurl ?? socialDetails?.profileurl ?? "";
  let formType =
    checkoutFormData?.data?.appuser_groups_by_formid?.[0]?.type ?? "";
  let allowSpeaker =
    (dynamicFormCommonSetting?.createspeaker ?? true) &&
    !(dynamicFormCommonSetting?.useProfilePhotoAsSpeakerImage ?? false);
  let createSpeaker = formType === "speaker" && allowSpeaker;

  let allowPhoneSignup = dynamicFormCommonSetting?.allowphonelogin ?? false; // Dynamic form phone login
  let emailOptional = dynamicFormCommonSetting?.emailoptional ?? false; // Dynamic form email is optional setting, Validate email field as per setting

  useEffect(() => {
    if (_.isEmpty(formValues) || _.isEmpty(formValues?.name)) {
      expressCheckoutCompletion();
    }
  }, []);

  const onProfileImageSave = (img) => {
    // console.log("img :- ", img);

    props.autofill("profileurl", img === "" ? "" : img);
  };
  const onSpeakerImageSave = (img) => {
    // console.log("img :- ", img);

    props.autofill("speakerprofileurl", img === "" ? "" : img);
  };

  const expressCheckoutCompletion = () => {
    if (!_.isEmpty(loginScreen) && !_.isEmpty(socialDetails)) {
      imagePreviewUrl = socialDetails?.profileurl ?? "";
      props.autofill("profileurl", socialDetails?.profileurl ?? "");
      props.autofill("firstname", socialDetails?.firstname ?? "");
      props.autofill("lastname", socialDetails?.lastname ?? "");
      props.autofill("email", socialDetails?.email ?? "");
    }
  };

  return (
    <>
      <div
        className={classNames(
          "grid grid-cols-4 grid-flow-row",
          createSpeaker
            ? "space-y-4 2md:space-y-0 2md:space-x-4 2md:grid-cols-9 lg:grid-cols-5"
            : "md:space-x-4 md:grid-cols-9 2md:grid-cols-12"
        )}
      >
        {profileOptionn !== "hide" ? (
          <div
            className={classNames(
              "col-span-4",
              createSpeaker
                ? "2md:col-span-2 lg:col-span-1"
                : "md:col-span-3 2md:col-span-3"
            )}
          >
            <div className="space-y-1 2xs:space-y-1.5">
              <label className="control-label-top col-span-12">
                {LocaleStrings.kLabelProfilePic}

                {profileOptionn === "mandatory" ? (
                  <span className="label-mandatory">*</span>
                ) : (
                  ""
                )}
              </label>
              <ImageCropper
                displaySize={
                  createSpeaker
                    ? { width: 180, height: 180 }
                    : { width: 210, height: 210 }
                } // For image display style
                requiredSize={{ width: 200, height: 200 }} // For image size required validation
                cropperSize={
                  createSpeaker
                    ? { width: 140, height: 140 }
                    : { width: 170, height: 170 }
                } // Cropper display size. Note its add 50px for padding
                onImageSave={onProfileImageSave}
                imagepath={imagePreviewUrl}
                border={10}
                displayText={LocaleStrings.kFileDragDropText}
                fileSizeText={LocaleStrings.kFileMinSizeText}
                imageType="jpg"
                baseClassName="APPUSER_PROFILE_IMG"
              />
              <Field
                name="profileurl"
                type="text"
                component={renderHiddenFieldText}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <div
          className={classNames(
            "base-form col-span-4",
            profileOptionn !== "hide"
              ? createSpeaker
                ? "2md:col-span-5 lg:col-span-3"
                : "md:col-span-6 2md:col-span-9"
              : "md:col-span-9 2md:col-span-12"
          )}
        >
          <Field
            name="firstname"
            label={LocaleStrings.kFirstName}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
          <Field
            name="lastname"
            label={LocaleStrings.kLastName}
            placeholder={""}
            type="text"
            component={renderFieldText}
            mandatory={true}
          />
          <div>
            <div className="lg:flex items-center justify-center gap-x-4">
              <div className="flex-1">
                <Field
                  name="email"
                  label={LocaleStrings.kEmail}
                  placeholder={""}
                  type="text"
                  component={renderFieldText}
                  mandatory={!emailOptional}
                />
              </div>
              {source === "registration" && allowPhoneSignup ? (
                <>
                  <div className="flex-shrink-0 pt-2 lg:pt-8">
                    {LocaleStrings.kOr}
                  </div>
                  <div className="flex-1">
                    <Field
                      name={"phone"}
                      label={LocaleStrings.kPhoneNumber}
                      type={"number"}
                      component={RenderFieldPhone}
                      mandatory={true}
                      countrycode={countrycode}
                      countryList={countryList}
                      isrestricted={dropdowndisabled}
                    />
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
            {source === "registration" && allowPhoneSignup ? (
              <Field
                name="registerwith"
                type="text"
                component={renderHiddenFieldText}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        {createSpeaker && profileOptionn !== "hide" ? (
          <div className="col-span-4 2md:col-span-2 lg:col-span-1">
            <div className="space-y-1 2xs:space-y-1.5">
              <label className="control-label-top col-span-12">
                {LocaleStrings.kSpeakerProfilePic}

                {profileOptionn === "mandatory" ? (
                  <span className="label-mandatory">*</span>
                ) : (
                  ""
                )}
              </label>
              <ImageCropper
                displaySize={{ width: 160, height: 240 }} // For image display style
                requiredSize={{ width: 320, height: 480 }} // For image size required validation
                cropperSize={{ width: 150, height: 225 }} // Cropper display size. Note its add 50px for padding
                onImageSave={onSpeakerImageSave}
                imagepath={speakerimagePreviewUrl}
                border={10}
                displayText={LocaleStrings.kFileDragDropText}
                fileSizeText={LocaleStrings.kFileMinSizeText}
                imageType="jpg"
                baseClassName="SPEAKER_PROFILE_IMG"
              />
              <Field
                name="speakerprofileurl"
                type="text"
                component={renderHiddenFieldText}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  let dynamicFormCommonSetting = JSON.parse(
    state?.checkoutFormData?.data?.commonsetting ?? "{}"
  );

  return {
    eventData: state.eventData,
    checkoutFormData: state.checkoutFormData,
    dynamicFormCommonSetting,
    countryList: state.countryList,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FixedFields);
